export const linkqualityFilter = feature => feature.property === 'linkquality';

export const batteryFilter = feature => feature.property === 'battery';
